export default {
    ARTICLE_SECTION: "ARTICLE_SECTION",
    PRESENTATION_BOX: "PRESENTATION_BOX",
    PRESENTATION_BLOCK: "PRESENTATION_BLOCK",
    PRESENTATION_CARD: "PRESENTATION_CARD",
    TROMBINOSCOPE: "TROMBINOSCOPE",
    BLOCK_TITLE: "BLOCK_TITLE",
    CONTACT_FORM: "CONTACT_FORM",
    BLOCK_WITH_TITLE: "BLOCK_WITH_TITLE",
    TEXT_BLOCK_WITH_TITLE: "TEXT_BLOCK_WITH_TITLE",
    DESCRIPTION_BLOCK: "DESCRIPTION_BLOCK",
    DESCRIPTION_CARD_WITH_LOGO: "DESCRIPTION_CARD_WITH_LOGO",
    TABS_COMPONENT: "TABS_COMPONENT",
    SUB_PAGE_REDIRECT: "SUB_PAGE_REDIRECT",
    GEOGRAPHIC_MAP: "GEOGRAPHIC_MAP",
    SUBPAGE_SEARCH: "SUBPAGE_SEARCH",
    MAILTO: "MAILTO",
    IFRAME: "IFRAME",
    HORIZONTAL_INFOS: "HORIZONTAL_INFOS",
    HORIZONTAL_INFO_ITEM: "HORIZONTAL_INFO_ITEM",
    PRODUCT_BLOCK: "PRODUCT_BLOCK",
    CONTACT_BLOCK: "CONTACT_BLOCK",
    CARDS_GRID: "CARDS_GRID",
    CARDS_GRID_ITEM: "CARDS_GRID_ITEM",
    AUTO_SCROLLING_INFOS: "AUTO_SCROLLING_INFOS",
    AUTO_SCROLLING_INFO_ITEM: "AUTO_SCROLLING_INFO_ITEM",
    SKILLS_TAB_PANEL: "SKILLS_TAB_PANEL",
    SKILL_BOX: "SKILL_BOX",
    DESCRIPTION_SECTION: "DESCRIPTION_SECTION",
    DESCRIPTION_SECTION_ITEM: "DESCRIPTION_SECTION_ITEM",
    DOCAPOSTE_SECTION: "DOCAPOSTE_SECTION",
    ARTICLE_CARD_LIST: "ARTICLE_CARD_LIST",
    ARTICLE_CARD_LIST_ITEM: "ARTICLE_CARD_LIST_ITEM",
};
